import { MdCable } from "react-icons/md";
import { RiDoorOpenFill } from "react-icons/ri";
import { IoIosRadio } from "react-icons/io";
import { LuParkingMeter } from "react-icons/lu";
import { TbCashRegister } from "react-icons/tb";
import Turnstile from "../icons/turnstile";

export const AccessIcons = {
	0: <MdCable />,
	1: <RiDoorOpenFill />,
	2: <IoIosRadio />,
	8: <Turnstile />,
	12: <RiDoorOpenFill />,
	13: <IoIosRadio />,
	14: <Turnstile />,
	16: <LuParkingMeter />,
	17: <TbCashRegister />,
}